import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../users/components/AuthProvider';

const ProtectedRouteAdmin = () => {
  const { userData } = useContext(AuthContext);
  if (!userData || !userData.is_admin) {
    return <Navigate to="/admin/login" />;
  }
  return <Outlet />;
};

export default ProtectedRouteAdmin;
